import { createPromiseEventBus } from '@/tools/promise-event-bus'

export const BMapPromiseEvent = createPromiseEventBus()

export const MapSdkPromiseEvent = createPromiseEventBus()